// @flow
import * as React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';
import firebase from 'firebase/app';

import ImageTextListItem from 'components/ImageTextListItem';
import NewAssignment from './NewAssignment';

type Props = {
  // redux
  me: Object,
  loading: boolean,
};

type State = {
  assignments: Array<Object>,
};

class Assignments extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    if (!!props.me) {
      this._createSnapshotListener(props.me);
    }
  }
  state = {
    assignments: [],
  };

  componentWillReceiveProps(next) {
    if (next.me && next.me.uid) {
      const { me } = next;
      this._createSnapshotListener(me);
    }
  }

  _createSnapshotListener = me => {
    firebase
      .firestore()
      .collection(`assignments`)
      .where('communityId', '==', me.communityId)
      .where('createdBy', '==', me.uid)
      .onSnapshot(async snap => {
        const assignments = await Promise.all(
          snap.docs.map(async doc => {
            const data = doc.data();

            return {
              ...data,
              images: await Promise.all(
                data.images.map(image =>
                  firebase
                    .storage()
                    .ref(image)
                    .getDownloadURL()
                )
              ),
              assignmentId: doc.id,
            };
          })
        );

        this.setState(prevState => ({ ...prevState, assignments }));
      });
  };

  render() {
    const { loading } = this.props;
    const { assignments } = this.state;

    return (
      <div className="animated fadeIn">
        <Container fluid>
          <Row>
            <Col>
              {loading ? (
                <div>Aufgaben werden geladen ...</div>
              ) : (
                assignments.map(assignment => (
                  <Link
                    key={assignment.assignmentId}
                    to={`/assignment/${assignment.assignmentId}`}
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    <ImageTextListItem
                      title={assignment.title}
                      description={assignment.description}
                      image={
                        assignment.images.length > 0
                          ? assignment.images[0]
                          : null
                      }
                      createdAt={assignment.createdAt}
                      commentsCount={
                        assignment.states.filter(s => s.type === 'comment')
                          .length
                      }
                    />
                  </Link>
                ))
              )}
            </Col>
            <Col xs="12" sm="12" md="12" lg="5" xl="5">
              <NewAssignment />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = ({ assignments: { loading }, auth }) => {
  const me = auth.firebaseUser;
  return {
    me,
    loading,
  };
};

const mapDispatchToProps = {
  // onLoadAssignments: loadAssignments,
};

const AssignmentsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Assignments);

export default AssignmentsContainer;



// WEBPACK FOOTER //
// ./src/views/Assignments/Assignments.js